<div class="instruments">
  <div class="pg-wrapper animated faster delay-0_5s fadeIn ">

    <div class="instruments__heading">
      <h1>Сервис по поиску музыкантов No1 в России и на Луне</h1>
    </div>
    <div class="instruments__switcher">
      <form [formGroup]="SwitcherForm" autocomplete="off">
        <div class="grid align-items-center justify-content-center">
          <div class="col-auto"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">

            <p class="instruments__switcher-item {{SwitcherStatus ? '' : 'active'}}" (click)="onSetSwitcher(false)">
              Объявления от музыкантов
            </p>
          </div>

          <div class="col-auto text-center"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'col-sm-3' : 'ml-4 mr-4'}}">

            <label class="ui-switcher"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'sm-view' : ''}}">

              <input type="checkbox" formControlName="type"/>
              <div class="ui-switcher__item"></div>
            </label>
          </div>

          <div class="col-auto"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">

            <p class="instruments__switcher-item {{SwitcherStatus ? 'active' : ''}}" (click)="onSetSwitcher(true)">
              Объявления от групп
            </p>
          </div>
        </div>
      </form>
    </div>
    <div class="instruments__balls ui-scroll-horizontal sm-scrollbar __js__instruments-slider">
      <div class="instruments__balls-item" (click)="onSearchLink(3)">
        <div class="mr-icon mr-icon-guitar"></div>
        <p>Гитара</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(63)">
        <div class="mr-icon mr-icon-electro-guitar"></div>
        <p>Электро гитара</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(78)">
        <div class="mr-icon mr-icon-bass"></div>
        <p>Бас гитара</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(87)">
        <div class="mr-icon mr-icon-voice"></div>
        <p>Вокал</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(120)">
        <div class="mr-icon mr-icon-tube"></div>
        <p>Духовые</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(76)">
        <div class="mr-icon mr-icon-drums"></div>
        <p>Барабаны</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(46)">
        <div class="mr-icon mr-icon-piano"></div>
        <p>Клавиши</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(50)">
        <div class="mr-icon mr-icon-violin"></div>
        <p>Скрипка</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(66)">
        <div class="mr-icon mr-icon-dj"></div>
        <p>DJ</p>
      </div>
      <div class="instruments__balls-item" (click)="onSearchLink(0)">
        <div class="mr-icon mr-icon-other"></div>
        <p>Другое</p>
      </div>
    </div>
  </div>
</div>
